var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#0088F5",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cross_svg__clip0_782_14060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 38.788l12.994-12.994 3.712 3.712L46.212 42.5l12.994 12.994-3.712 3.711L42.5 46.212 29.507 59.205l-3.712-3.711L38.789 42.5 25.795 29.506l3.712-3.712L42.5 38.788z",
    fill: "#D4D4D8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross_svg__clip0_782_14060"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11 11)",
    d: "M0 0h63v63H0z"
  })))));
}
export default SvgCross;